import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Language, PaymentChannelType } from 'app/model/constant';
import { PaymentOption } from 'app/model/dropdown/dropdown-option-model';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-payment-channel-select-box',
  templateUrl: './payment-channel-select-box.component.html',
  styleUrls: ['./payment-channel-select-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentChannelSelectBoxComponent),
      multi: true
    }
  ]
})
export class PaymentChannelSelectBoxComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  @Input() setElementIdPage = 'payment-select-box';
  @Input() optionList: PaymentOption[] = [];
  @Input() placeHolder = 'Please select';
  @Input() error = false;

  @Output() onSelectPaymentChannel: EventEmitter<string> = new EventEmitter();

  @ViewChild('selectBox') selectBox: ElementRef;

  public paymentChannelType = PaymentChannelType;
  public Language = Language;
  public lang: string;
  public isOpenMenu = false;

  public onChange: Function;
  public onTouch: Function;
  public currentOption: PaymentOption;
  public isMobile;
  public selectBoxWidth;

  constructor(
    private utilitiesService: UtilitiesService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utilitiesService.isMobile();
  }

  ngAfterViewInit() {
    if (document.getElementById(`${this.setElementIdPage}-select-box`).clientWidth === 0) {
      this.selectBoxWidth = window.innerWidth - 18 + 'px';
    } else {
      this.selectBoxWidth = (document.getElementById(`${this.setElementIdPage}-select-box`).clientWidth + 2) + 'px';
    }
    this.cdr.detectChanges();
  }

  writeValue(value: string) {
    if (value && this.optionList && this.optionList.length > 0) {
      const option = this.optionList.find(f => f.value === value);
      this.onSelect(option);
    }
  }

  registerOnChange(onChange: Function) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouch: Function) {
    this.onTouch = onTouch;
  }

  onSelect(option: PaymentOption) {
    if (option !== this.currentOption) {
      this.currentOption = option;
      this.onSelectPaymentChannel.emit(option.value);
    }
  }

  onOpenMenu() {
    this.onTouch(true);
    this.isOpenMenu = true;
  }

  onCloseMenu() {
    this.isOpenMenu = false;
  }

  onScrollTo() {
    this.selectBox.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/payment-channel-select-box/payment-channel-select-box.component.ts